import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

/** The requesting user's profile from the payload; `null` until the payload arrives. */
export const selectCockpitUserInfo = createSelector(
  [selectFinancialCockpitState],
  ({ userInfo }) => userInfo
)

/** Geographic breadth of the user's dashboards — what the manager cockpit groups partners by. */
export const selectCockpitAccessLevel = createSelector(
  [selectCockpitUserInfo],
  (userInfo) => userInfo?.AccessLevel
)
